import { render, staticRenderFns } from "./SopReveal.vue?vue&type=template&id=0205a6fc&"
import script from "./SopReveal.vue?vue&type=script&lang=js&"
export * from "./SopReveal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0205a6fc')) {
      api.createRecord('0205a6fc', component.options)
    } else {
      api.reload('0205a6fc', component.options)
    }
    module.hot.accept("./SopReveal.vue?vue&type=template&id=0205a6fc&", function () {
      api.rerender('0205a6fc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/dashboard/admin/components/SopSetting/SopReveal.vue"
export default component.exports